import {
  TextareaAutosize,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox
} from '@mui/material';
import './Questions.scss';

const Questions = ({ question, feedbackId, handleAnswerChange, answers, index }) => {
  const questionId = question?.questionId;
  const inputId = `question-${questionId}`;
  const isPreview = feedbackId === null;
  const currentAnswer = answers[questionId];
  const isAnswered =
    currentAnswer !== undefined &&
    currentAnswer !== null &&
    currentAnswer !== '' &&
    !(Array.isArray(currentAnswer) && currentAnswer.length === 0);

  const handleChange = (e, question) => {
    handleAnswerChange(question?.questionId, e.target.value);
  };

  const handleOnChange = (e, question) => {
    const qId = question.questionId;
    const isChecked = e.target.checked;
    const currentValues = answers[qId] || [];
    const updatedValues = isChecked
      ? [...currentValues, e.target.value]
      : currentValues.filter(v => v !== e.target.value);
    handleAnswerChange(question?.questionId, updatedValues);
  };

  const renderQuestionInput = question => {
    switch (question.questionType) {
      case 'text':
        return (
          <TextareaAutosize
            id={inputId}
            aria-label={question.questionDescription}
            minRows={3}
            className="feedbackTextarea"
            disabled={isPreview}
            placeholder="Type your answer here…"
            value={answers[question?.questionId] || ''}
            onChange={e => handleChange(e, question)}
          />
        );
      case 'rating':
        return (
          <FormControl disabled={isPreview} className="ratingControl">
            <RadioGroup
              className="optionChipGroup"
              aria-labelledby={`${inputId}-label`}
              name={`question-${question?.templateQuestionsId || questionId}`}
              value={answers[question?.questionId] || ''}
            >
              {question?.questionOptions?.map(({ value, name }) => {
                const selected = answers[question?.questionId] === name;
                return (
                  <FormControlLabel
                    className={`optionChip${selected ? ' isSelected' : ''}`}
                    key={value}
                    value={name}
                    control={<Radio className="optionChipRadio" size="small" />}
                    label={name}
                    onChange={e => handleChange(e, question)}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        );
      case 'multiSelect':
      default:
        return (
          <FormControl className="multiSelectControl" disabled={isPreview}>
            <div className="optionChipGroup isStacked">
              {question?.questionOptions?.map(({ value, name }) => {
                const selected = (answers[question?.questionId] || []).includes(name);
                return (
                  <FormControlLabel
                    className={`optionChip${selected ? ' isSelected' : ''}`}
                    key={value}
                    value={name}
                    control={<Checkbox className="optionChipRadio" size="small" />}
                    label={name}
                    onChange={e => handleOnChange(e, question)}
                  />
                );
              })}
            </div>
          </FormControl>
        );
    }
  };

  return (
    <div className={`questionBlock${isAnswered ? ' isAnswered' : ''}`}>
      <div className="questionHeader">
        <span className="questionIndex" aria-hidden="true">
          {index}
        </span>
        <div className="questionHeading">
          <label id={`${inputId}-label`} htmlFor={inputId} className="questionTitle">
            {question.questionDescription}
            {!isPreview && (
              <span className="requiredMark" aria-hidden="true">
                {' '}
                *
              </span>
            )}
          </label>
          {!isPreview && (
            <span className="questionMeta">{isAnswered ? 'Answered' : 'Required'}</span>
          )}
        </div>
      </div>
      <div className="questionBody">{renderQuestionInput(question)}</div>
    </div>
  );
};

export default Questions;
